import { Component, OnInit } from '@angular/core';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import Swal from 'sweetalert2'
import { NotifService } from 'src/app/_services/notif.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AffectationService } from 'src/app/_services/affectation/affectation.service';
import { AuthService } from 'src/app/_services/auth/auth.service';
declare const $;
@Component({
  selector: 'app-all-affectation',
  templateUrl: './all-affectation.component.html',
  styleUrls: ['./all-affectation.component.scss']
})
export class AllAffectationComponent implements OnInit {

  affectations: any;
  drivers: any;
  loading: boolean = true;
  @BlockUI() blockUI: NgBlockUI;

  //SweetAlert Text
  areYouSure = '';
  warning = ''
  yes = '';
  no = '';
  deleted = '';
  deletedMessage = '';
  cancelled = '';
  cancelledMessage = '';
  canCreate = false;
  canUpdate = false;
  canDelete = false;
  page = 1;
  data: any;
  driverSelectId: any;
  idDriver;
  limit = 1000000000;

  constructor(
    private affectationService: AffectationService,
    private authService: AuthService,
    private notifService: NotifService,
    private translate: TranslateService,
    private router: Router) {

    this.translate.get(
      ['SweetAlert.AreYouSure', 'SweetAlert.Warning', 'SweetAlert.Yes', 'SweetAlert.No', 'SweetAlert.Deleted',
        'SweetAlert.DeletedMessage', 'SweetAlert.Cancelled', 'SweetAlert.CancelledMessage'],
      { data: "cette affectation" })
      .subscribe(val => {
        this.areYouSure = val['SweetAlert.AreYouSure'];
        this.warning = val['SweetAlert.Warning'];
        this.yes = val['SweetAlert.Yes'];
        this.no = val['SweetAlert.No'];
        this.deleted = val['SweetAlert.Deleted'];
        this.deletedMessage = val['SweetAlert.DeletedMessage'];
        this.cancelled = val['SweetAlert.Cancelled'];
        this.cancelledMessage = val['SweetAlert.CancelledMessage'];
      });
  }
  ngOnInit() {
    console.log('theo')
    this.getAffectation(this.page);
    this.getDrivers(this.limit);
    const permissionSuffix = 'affectations';
    this.canCreate = this.authService.hasPermission(`${permissionSuffix}-create`);
    this.canUpdate = this.authService.hasPermission(`${permissionSuffix}-update`);
    this.canDelete = this.authService.hasPermission(`${permissionSuffix}-delete`);
  }

  getAffectation(page) {
    this.loading = true;
    this.affectationService.gets(page).then(
      response => {
        this.affectations = response;
        console.log(this.affectations);
        $(function () {
          $("#example1").DataTable({
            "responsive": true, "lengthChange": false, "autoWidth": false,
            "buttons": ["copy", "csv", "excel", "pdf", "print", "colvis"]
          }).buttons().container().appendTo('#example1_wrapper .col-md-6:eq(0)');
        });
      }
    ).catch(
      error => {
        this.notifService.danger(error.error.message)
      }
    ).finally(
      () => {
        this.loading = false;
      }
    )
  }

  getDrivers(limit) {
    this.affectationService.getdriver(limit).then((res) => {
      this.drivers = res;
      console.log(res)
    }, (error) => {
      this.notifService.danger(error.error.message)

    });
  }


  getPage(url) {
    if (url) {
      this.affectationService.get(url).then((res) => {
        this.affectations = res;
        console.log(this.affectations)
      }).catch(
        error => {
          this.notifService.danger(error.error.message)
        }
      ).finally(
        () => {
          this.loading = false;
        }
      )
    }
  }

  editaffectation(id) {
    console.log('bonjour');
    this.router.navigate(['/affectations/update/' + id])
    this.getVehicleDriver(this.idDriver);

  }
  detailleaffectation(id) {
    console.log('bonjourhaut');
    this.router.navigate(['/affectations/detaille/' + id])
    console.log('bonjourmi');

    this.getVehicleDriver(this.idDriver);
    console.log('bonjour');
  }

  getVehicleDriver(driver_id) {
    this.affectationService.findvehicledriver(driver_id).then((res) => {
      this.affectations = res;
      console.log(this.affectations)
      console.log('leprince')
    }, (error) => {
      this.notifService.danger(error.error.message)

    });
  }
  chooseDriver(event) {
    this.idDriver = event.target.value;
    console.log(this.idDriver);
    this.getVehicleDriver(this.idDriver);
    console.log('theo')
  }

  deleteaffectation(id) {
    Swal.fire({
      title: this.areYouSure,
      text: this.warning,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.yes,
      cancelButtonText: this.no
    }).then((result) => {
      if (result.value) {
        this.blockUI.start('Loading...');
        this.affectationService.deleteaff(id).then(
          data => {
            this.blockUI.stop();
            Swal.fire(
              this.deleted,
              this.deletedMessage,
              'success'
            )
            this.getVehicleDriver(this.idDriver);

          }
        ).catch(
          error => {
            console.log(error)
            this.blockUI.stop();
            this.translate.get('Affectation.' + error.error.code)
              .subscribe(val => this.notifService.danger(val));
          }
        )

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          this.cancelled,
          this.cancelledMessage,
          'error'
        )
      }
    })
  }
}
